/* eslint-disable */
import create_update from "../apollo/countries/create_update_rules.gql";
import listing from "../apollo/countries/fetch_rules.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Aug 2023 | 10:29AM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Aug 2023 | 10:29AM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Aug 2023 | 10:29AM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Aug 2023 | 10:31AM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.fetch_countries_rules);
          resolve(data.fetch_countries_rules);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Aug 2023 | 10:31AM
   * @param {*} { commit }
   * @returns {*}
   */
  createUpdate({ commit }, payload) {
    commit("setCreating", true);
    return new Promise(async (resolve) => {
      const _result = await this.$apolloClient
        .mutate({ mutation: create_update, variables: { payload } })
        .then(({ data }) => data?.create_update_counties_rules);
      commit("setCreating", false);
      if (_result) {
        resolve(_result);
      }
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
